import { MDBBtn } from 'mdb-react-ui-kit';

export default function GreetingAlertPopup({ isOpen, popupheading, message, mode = "ok", onOk, onContinue, onCancel }) {
    if (!isOpen) return null;
    return (
        <div
            className="modal show d-block"
            style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999 }}
            tabIndex="-1"
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{popupheading}</h5>
                    </div>
                    <div className="modal-body text-start">
                        <p>{message}</p>
                    </div>
                    <div className="modal-footer">
                        {mode === "ok" ? (
                            <MDBBtn onClick={onOk}>OK</MDBBtn>
                        ) : (
                            <>
                                <MDBBtn color="secondary" onClick={onCancel}>Cancel</MDBBtn>
                                <MDBBtn onClick={onContinue}>Continue</MDBBtn>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
